import {Component, ViewChild, Input, ElementRef, Renderer2} from '@angular/core';

import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import { SupplierSchedule } from 'app/buffer-graph/models/suppliers-schedules/supplier-schedule';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import {TranslateService} from "@ngx-translate/core";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import * as moment from "moment";
import {ExcelWorkService} from "../../../services/excel-work.service";
import {ModuleTableName} from "../../../shared/models/module-table-name";
import {ExportExcelColumn} from "../../../shared/models/export-excel-column";

@Component({
    selector: 'chart-data',
    templateUrl: './chart-data.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './chart-data.component.css']
})
export class ChartDataComponent extends TabComponentBase<SupplierSchedule, { columns: ExportExcelColumn[], mainRows: any[] }> {
    constructor(
        graphService: BufferGraphService,
        exchangeService: BufferGraphDataExchangeService,
        excelService: ExcelWorkService,
        translateService: TranslateService,
        renderer: Renderer2,
        elementRef: ElementRef
    ){
        super(graphService, exchangeService, excelService, translateService, renderer, elementRef);

        this.dataView = new Slick.Data.DataView<any>();
        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };
        this.generateColumns = true;
        this.gridPropsName = new ModuleTableName('Stocks', 'ChartData')

        this.translateService.get('ChartData').subscribe(t => this.mainRowsSheetName = t);


    }

    @Input()
    public isActive: boolean;

    @Input()
    private set data(chartData: any[]) {
        this.dataView.setItems(chartData);
    }

    @Input()
    public canSend: boolean;

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# download excel
    public onDownloadClick = (): void => {
        const fileName = `${this.mainRowsSheetName}_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.excelService.downloadReport(
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            []
        )
            .map(file => { return { fileContent: file, fileName }; }));
    }

    //# send excel to email
    public onSendClick = (): void => {
        this.sendToEmail(data => this.excelService.sendReport(
            this.tab.itemInfo.sku,
            this.tab.itemInfo.warehouseCode,
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            [],
            this.mainRowsSheetName
        ));
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/chart-data.component/chart-data.component.ts